import * as React from "react";
export class InstantCollapsible extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = (e) => {
            this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
            e.stopPropagation();
        };
        this.state = {
            collapsed: !this.props.initiallyExpanded
        };
    }
    render() {
        return (React.createElement("div", { className: "rj-instant-collapsible", "data-collapsed": this.state.collapsed },
            React.createElement("div", { className: "rj-instant-collapsible__trigger", onClick: this.toggle }, this.props.trigger),
            !this.state.collapsed && this.props.content));
    }
}
//# sourceMappingURL=InstantCollapsible.js.map